import { useState, useRef, useEffect } from "react";

const ThreeDotMenu = ({ userId, formData, token }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [blockStatus, setBlockStatus] = useState(
    formData?.is_blocked || false
  );

  const menuRef = useRef(null);

  // Close menu on outside click
  useEffect(() => {
    const closeMenu = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", closeMenu);
    return () => document.removeEventListener("mousedown", closeMenu);
  }, []);

  // Block / Unblock
  const fetchBlockStatus = async (shouldBlock) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL_API}/api/user/member-block-status`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            block_member_id: formData?._id,
            action: shouldBlock ? "block" : "unblock",
          }),
        }
      );

      const data = await response.json();

      if (data?.status) {
        setBlockStatus(shouldBlock);
        setMenuOpen(false);
      } else {
        alert(data?.message || "Action failed");
      }
    } catch (error) {
      console.error("Block Error:", error);
      alert("Something went wrong");
    }
  };

  // Report
  const submitReport = async () => {
    if (!comment.trim()) {
      alert("Please write a comment");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL_API}/api/user/report-member`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            report_member_id: formData?._id,
            comment,
          }),
        }
      );

      const data = await response.json();

      if (data?.status) {
        alert("Report submitted successfully");
        setComment("");
        setReportOpen(false);
      } else {
        alert(data?.message || "Report failed");
      }
    } catch (error) {
      console.error("Report Error:", error);
      alert("Failed to submit report");
    }
  };

useEffect(() => {
    setBlockStatus(formData?.is_blocked || false);
  }, [formData]);
  
  return (
    <>
      <div className="menu-container" ref={menuRef}>
        <button className="dot-btn" onClick={() => setMenuOpen(!menuOpen)}>
          ⋮
        </button>

        {menuOpen && (
          <div className="menu-popup">
            <button onClick={() => fetchBlockStatus(!blockStatus)}>
              {blockStatus ? "Unblock" : "Block"}
            </button>

            <button
              className="danger"
              onClick={() => {
                setMenuOpen(false);
                setReportOpen(true);
              }}
            >
              Report
            </button>
          </div>
        )}
      </div>

      {reportOpen && (
        <div className="modal-overlay">
          <div className="report-modal">
            <h2>Report User</h2>

            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Write your comment..."
            />

            <div className="modal-actions">
              <button className="cancel" onClick={() => setReportOpen(false)}>Cancel</button>
              <button className="submit" onClick={submitReport}>Submit</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ThreeDotMenu;
